import { render, staticRenderFns } from "./distributor-setting.vue?vue&type=template&id=569ebaf1"
import script from "./distributor-setting.vue?vue&type=script&lang=js"
export * from "./distributor-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports